<script setup lang="ts">
import { inject } from 'vue';
import { useJobBoardStore } from '@/core/collections/job-boards/job-board.store';

const props = defineProps({
   data: {
      type: Object,
      default: () => ({}),
   },
});

const viewport = inject<'desktop' | 'tablet' | 'mobile'>('viewport');

const jobBoardStore = useJobBoardStore();
const activeLang = computed(() => jobBoardStore.activeLanguageName);
const text = computed(() => props.data.text[activeLang.value] || '');
</script>

<template>
   <article v-if="text" :class="['text-content', { 'text-content--mobile': viewport === 'mobile' }]">
      <span v-html="text"></span>
   </article>
   <div v-else>TextBlock (No text configured)</div>
</template>

<style lang="scss" scoped>
.text-content {
   max-width: 1000px;
   padding: 0 100px;
   margin: 0 auto;
   text-align: center;

   &--mobile {
      padding: 0 30px;
   }

   @media (max-width: 400px) {
      padding: 0 30px;
   }
}
</style>
